import styled from "@emotion/styled"
import { Button } from "@mui/material"
import moment from "moment"
import Link from "next/link"
import { useState } from "react"
import colors from "theme/colors"
import { Container, FileIcon2, NewText, TabPanel, TabTitle } from "ui"
import { sharedColors } from "ui/theme/colors"
import { buttonClick, extractProperty, getUmbracoMediaUrl, getUmbracoPDFUrl } from "utils"
import YouTubePlayer from "./YouTubePlayer"

const StyledPageDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 0px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 0px;
  }
`

const StyledVideosDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 40px;
  }
`

const StyledVideoWrapper = styled.div`
  border: 1px solid #6f6f6f;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`

type Props = {
  data: any
  additional: string
  children: React.ReactNode
}

const StyledVideo = styled(YouTubePlayer)`
  max-width: 100%;
  width: 100%;
`

const StyledBottomDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-self: end;
  margin-top: auto;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    margin-right: 4px;
  }
  min-width: 50%;
`

const StyledButtonDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
`

const StyledMainDiv = styled.div``

function ConferenceVideoMain({ data, additional, children }: Props) {
  const title = extractProperty(data, "title")
  const videosTabs = extractProperty(data, "conferenceVideoTabs")
  const [count, setCount] = useState(9)
  const [value, setValue] = useState(0)

  const endsWithPDF = (url: string) => {
    return /\.pdf$/.test(url)
  }

  const onHandleButton = () => {
    setCount((prev) => prev + 9)
  }

  return (
    <Container>
      <StyledPageDiv>
        {children}
        <NewText
          component={"h1"}
          desktopFontSize={40}
          desktopLineHeight={"44px"}
          desktopFontWeight={400}
          mobileFontSize={32}
          mobileLineHeight={"36px"}
          color={colors.black}
          marginTop={"32px"}
        >
          {title}
        </NewText>
        <TabTitle tabs={videosTabs} setValue={setValue} value={value} eventName="דיווחים מידיים" />
        {videosTabs.map((block: any, index: number) => {
          const videoBlock = block.properties.find(
            (prop: any) => prop.propertyName === "videosPicker",
          )?.propertyValue?.blocks
          return (
            <TabPanel value={value} index={index} key={"panel" + index.toString()}>
              <StyledMainDiv>
                <StyledVideosDiv>
                  {videoBlock.map((video: any, k: number) => {
                    const youTube = extractProperty(video, "youTube")
                    const text = extractProperty(video, "text")
                    const date = extractProperty(video, "date")
                    const linkToFile = extractProperty(video, "linkToFile")

                    return (
                      <StyledVideoWrapper key={k.toString()}>
                        <StyledVideo url={youTube[0]?.url} noMargin key={k} />
                        <NewText
                          component={"h2"}
                          desktopFontSize={18}
                          desktopLineHeight={"26px"}
                          desktopFontWeight={400}
                          mobileFontSize={16}
                          mobileLineHeight={"23px"}
                          color={colors.black}
                        >
                          {text}
                        </NewText>
                        <StyledBottomDiv>
                          <StyledLink
                            href={
                              endsWithPDF(linkToFile[0]?.url)
                                ? getUmbracoPDFUrl(linkToFile[0]?.url)
                                : getUmbracoMediaUrl(linkToFile[0]?.url)
                            }
                            target="_blank"
                            onClick={() => buttonClick(linkToFile[0]?.name, title)}
                          >
                            <FileIcon2 width={20} height={20} />
                            <NewText
                              desktopFontSize={14}
                              desktopFontWeight="400"
                              desktopLineHeight="20px"
                              mobileFontSize={12}
                              style={{ borderBottom: "1px solid black" }}
                              mobileFontWeight="400"
                              mobileLineHeight={"17px"}
                              component="p"
                              color={sharedColors.black}
                            >
                              {linkToFile[0]?.name}
                            </NewText>
                          </StyledLink>
                          <NewText
                            desktopFontSize={16}
                            desktopFontWeight="400"
                            desktopLineHeight="23px"
                            mobileFontSize={14}
                            mobileFontWeight="400"
                            mobileLineHeight={"20px"}
                            component="p"
                            color={sharedColors.gray}
                          >
                            {moment(date).format("DD/MM/YYYY")}
                          </NewText>
                        </StyledBottomDiv>
                      </StyledVideoWrapper>
                    )
                  })}
                </StyledVideosDiv>
                {count < videoBlock?.length && (
                  <StyledButtonDiv>
                    <Button onClick={onHandleButton} variant="text" size="small">
                      {additional}
                    </Button>
                  </StyledButtonDiv>
                )}
              </StyledMainDiv>
            </TabPanel>
          )
        })}
      </StyledPageDiv>
    </Container>
  )
}
export default ConferenceVideoMain
